import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateCategory'
})

export class TranslateCategoryPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        let output: string = ' ...';

        switch (value) {
            case 'Structure':
                output = 'Aktenzeichen';
                break;
            case 'Folder':
                output = 'Teilakten/Vorgänge';
                break;
            case 'Document':
                output = 'Schriftstücke';
                break;
            case 'Address':
                output = 'Adressen';
                break;
            case 'Meeting':
                output = 'Sitzungen';
                break;
            case 'Global':
                output = 'Übergreifend';
                break;
        }
        return output;
    }
}



// WEBPACK FOOTER //
// ./src/shared/translate-category.pipe.ts